import React, {useState} from "react"
import {useSelector} from "react-redux"
import {getDeletedMatrixItems} from "../../../state/product/ProductSelectors"
import RestoreMatrixItemModal from "../modal/RestoreMatrixItemModal"
import {defineMessages, injectIntl} from "react-intl"
import {Intl} from "../../../state/helpers/IntlProps"

const messages = defineMessages({
    restore_items: {
        id: "product.variant.modal.restore_matrix_item_modal.header_name",
        defaultMessage: "Restore Deleted Variants"
    },
})

type Props = {
    intl: Intl
}

const MatrixItemsRestoreSection = (props: Props) => {
    const [modal, setModal] = useState(<></>)
    const deletedItems = useSelector(getDeletedMatrixItems)

    if (!deletedItems.length) return <></>

    return (
        <div>
            {modal}

            <a href={"#"} className={"m-2 float-right"}
                onClick={e => {
                    e.preventDefault()
                    setModal(
                        <RestoreMatrixItemModal
                            onCloseCallback={() => setModal(<></>)}
                        />
                    )
                }}>
                {props.intl.formatMessage(messages["restore_items"])}
            </a>
        </div>
    )
}

export default injectIntl(MatrixItemsRestoreSection)


// WEBPACK FOOTER //
// ./src/product/variant/section/MatrixItemsRestoreSection.tsx